<!-- <div class="rtl appContain"> -->
<div class="appContain">

    <!-- This nav gives you links to click, which tells the router which route to use (defined in the routes constant in  AppRoutingModule) -->

    
    <header class="dt2-background no-border ">

        <nav class="navbar navbar-expand-lg navbar-dark">

            <a class="navbar-brand" href="//app.doc2txt.com">
                <img [src]="logoSrc" height="40" alt="" loading="lazy"/>
            </a>
            
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item" *ngFor="let item of navMenu">
                        <a class="nav-link" [ngClass]="{'active' : item.active}" [routerLink]="item.link" >{{ item.name }}</a>
                    </li>
      

                    <li class="nav-item">
                        <a class="nav-link" href="/user">
                            <div [hidden]="user">{{ 'User Login' | i18n }}</div>
                            {{ user?.attributes?.email }}</a>
                    </li>
                </ul>
            </div>


            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            
        </nav>
    </header>
    <!-- The routed views render in the <router-outlet>-->
    <div class="Doc2TxtContainPage">

        <div class="grad-bg"></div>
        <div class="Doc2TxtContainPage-content">

            <router-outlet></router-outlet>
        </div>

    </div>
</div>